// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.red-text {
  font-weight: bold;
  color: var(--ion-color-danger);
}

ion-toggle {
  margin: 0px 18px 0px 2px;
}

ion-thumbnail {
  margin-right: 18px;
  --size: 58px;
}

ion-grid {
  padding: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/quote/quote-email-add-rec-file-modal/quote-email-add-rec-file-modal.page.scss","webpack://./../../../../../../Program%20Files%20(x86)/Jenkins/workspace/Quadra%20Service%20Call%20Pipeline/QuadraServiceCall/Client/src/app/pages/quote/quote-email-add-rec-file-modal/quote-email-add-rec-file-modal.page.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,8BAAA;ACCJ;;ADEA;EACI,wBAAA;ACCJ;;ADEA;EACI,kBAAA;EACA,YAAA;ACCJ;;ADEA;EACI,YAAA;ACCJ","sourcesContent":[".red-text {\r\n    font-weight: bold;\r\n    color: var(--ion-color-danger);\r\n}\r\n\r\nion-toggle {\r\n    margin: 0px 18px 0px 2px;\r\n}\r\n\r\nion-thumbnail {\r\n    margin-right: 18px;\r\n    --size: 58px;\r\n}\r\n\r\nion-grid {\r\n    padding: 0px;\r\n}\r\n",".red-text {\n  font-weight: bold;\n  color: var(--ion-color-danger);\n}\n\nion-toggle {\n  margin: 0px 18px 0px 2px;\n}\n\nion-thumbnail {\n  margin-right: 18px;\n  --size: 58px;\n}\n\nion-grid {\n  padding: 0px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
